import React, { Component } from 'react';
import { Loader } from 'react-loaders';

import { batchRequest } from '../../../../../../api/ApiService';

import ProfilePicture1 from '../../../../../../containers/assets/answers-profile-pic-1.png';
import ProfilePicture2 from '../../../../../../containers/assets/answers-profile-pic-2.png';
import ProfilePicture3 from '../../../../../../containers/assets/answers-profile-pic-3.png';
import ProfilePicture4 from '../../../../../../containers/assets/answers-profile-pic-4.png';

import {
  Wrapper,
  PreTitle,
  Title,
  Text,
  ContentContainer,
  UserAnswer
} from '../../../components/ui';
import SelectorWrapper from '../../../components/selector-wrapper';
import AnswersPagination from '../../../components/answers-pagination';
import { answersRowsPerPage } from '../../../constants';

const profilePictures = [
  ProfilePicture1,
  ProfilePicture2,
  ProfilePicture3,
  ProfilePicture4
]

const randomIntFromInterval = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

class DoDifferently extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedUserId: 0,
      loaded: false,
      biggestTakeawayItems: [],
      biggestTakeawayItemsToShow: [],
      rowsPerPage: answersRowsPerPage[0].name,
      rowsTotal: 0,
      page: 1,
      activePrevPage: null,
      activeNextPage: null
    };
  }

  async componentDidMount() {
    const { currentFinishedSurvey } = this.props;
    const { rowsPerPage } = this.state;
    batchRequest([
      `${process.env.REACT_APP_API_URL}users`,
      `${process.env.REACT_APP_API_URL}v2/forms/answers-list/?survey=${currentFinishedSurvey.id}`,
    ])
      .then(res => {
        const users = res[0].body;
        const formsAnswersList = res[1].body.results;
        const biggestTakeawayAnswers = formsAnswersList.filter(formsAnswer => formsAnswer.question_text.toLowerCase().includes('chance to do it all over again'));

        const biggestTakeawayItems = [...new Set(biggestTakeawayAnswers.map(item => {
          const user = users.find(user => user.email === item.giver_email);
          const firstName = user.first_name;
          const lastName = user.last_name;
          const showDotFirstName = firstName.length > 1 ? '.' : '';
          const showDotLastName = lastName.length > 1 ? '.' : '';
          return {
            displayName: `${firstName.substring(0, 1)}${showDotFirstName} ${lastName.substring(0, 1)}${showDotLastName}`,
            tooltip: `${user.first_name} ${user.last_name}`,
            answer: item.answer_text
          }
        }))];

        const rowsTotal = biggestTakeawayItems.length;

        this.setState({
          loaded: true,
          biggestTakeawayItems,
          biggestTakeawayItemsToShow: biggestTakeawayItems.slice(0, rowsPerPage),
          rowsTotal,
          activeNextPage: rowsPerPage < rowsTotal
        });
      })
      .catch(err => { });
  }

  get teamPlayersOptions() {
    return [{ id: 0, name: 'Overall' }];
  }

  handlePageChange = (page) => {
    const {
      rowsPerPage,
      rowsTotal,
      biggestTakeawayItems
    } = this.state;

    this.setState({
      page: page,
      biggestTakeawayItemsToShow: biggestTakeawayItems.slice(rowsPerPage * (page - 1), rowsPerPage * page),
      activePrevPage: rowsPerPage < (rowsPerPage * page) - 1,
      activeNextPage: (rowsPerPage * page) < rowsTotal
    });
  }

  handleRowsPerPageChange = (index) => {
    const {
      rowsTotal,
      biggestTakeawayItems
    } = this.state;

    const rowsPerPage = answersRowsPerPage[index].name;

    this.setState({
      page: 1,
      rowsPerPage: answersRowsPerPage[index].name,
      activeNextPage: rowsPerPage < rowsTotal,
      biggestTakeawayItemsToShow: biggestTakeawayItems.slice(0, rowsPerPage),
      selectedOptionId: index
    });
  }

  render() {
    const {
      selectedUserId,
      loaded,
      biggestTakeawayItemsToShow,
      rowsPerPage,
      rowsTotal,
      page,
      activePrevPage,
      activeNextPage
    } = this.state;

    const options = this.teamPlayersOptions;

    return (
      <Wrapper>
        <PreTitle>Team</PreTitle>
        <Title>What Would You Do Differently</Title>
        <Text>
          <p>Students were asked if they had a chance to do it all over again, what would they do differently? Below are their answers. </p>
        </Text>
        <SelectorWrapper
          label={'View'}
          options={options}
          selectedOptionId={selectedUserId}
        />
        {
          !loaded &&
          <Loader type="ball-scale-ripple" active />
        }
        {
          loaded &&
          <div>
            <ContentContainer transparent maxHeight="578px">
              {
                biggestTakeawayItemsToShow.map((item, index) => (
                  <UserAnswer.Item key={index}>
                    <UserAnswer.Profile>
                      <UserAnswer.AvatarWrapper>
                        <img src={profilePictures[randomIntFromInterval(0, 3)]} alt="Profile avatar" title={item.tooltip} />
                      </UserAnswer.AvatarWrapper>
                      <UserAnswer.Username title={item.tooltip}>{item.displayName}</UserAnswer.Username>
                    </UserAnswer.Profile>
                    <UserAnswer.Text>{item.answer}</UserAnswer.Text>
                  </UserAnswer.Item>
                ))
              }
            </ContentContainer>
            <AnswersPagination
              rowsPerPage={rowsPerPage}
              handleRowsPerPageChange={this.handleRowsPerPageChange}
              rowsTotal={rowsTotal}
              page={page}
              handlePageChange={this.handlePageChange}
              activePrevPage={activePrevPage}
              activeNextPage={activeNextPage}
            />
          </div>
        }
      </Wrapper>
    );
  }

}

export default DoDifferently;



// WEBPACK FOOTER //
// ./src/instructor/components/peer-feedback/pages/dynamics/team/do-differently.js